import * as React from 'react';
import { Paragraph } from '@flightstats/airframe-react';

interface NoWrapParagraphProps {
  children: React.ReactNode;
  className?: string;
  bold?: boolean;
  inline?: boolean;
}

export const NoWrapParagraph: React.FC<NoWrapParagraphProps> = ({
  children,
  className,
  bold,
  inline,
  ...rest
}) => (
  <Paragraph {...rest} limitWidth={false} spacing={0} className={className} bold={bold} inline={inline}>
    {children}
  </Paragraph>
);